import React, { FC } from 'react'

export type StyledValuationBarProps = {
  width: number
  left: number
  largeValuationBar?: boolean
  informationMessage?: string
  isMobile?: boolean
  backgroundColor?: string
  progressColor?: string
}

const StyledValuationBar: FC<StyledValuationBarProps> = (props: StyledValuationBarProps) => {
  const { width, left, largeValuationBar, informationMessage, isMobile, backgroundColor, progressColor } = props
  return (
    <div
      className={largeValuationBar ? 'valuation-bar-l' : 'valuation-bar-m'}
      data-testid='valuation-range-container'
      style={{ background: backgroundColor }}
    >
      <div className='valuation-big'>
        <div
          data-testid='narrow-attribute-id'
          className='valuation-bar-range pin-underneath'
          style={{
            width: width + '%',
            left: left + '%',
            background: progressColor,
          }}
        />
      </div>
      {informationMessage && (
        <div
          className={isMobile ? 'font-xs margin-top-xl' : 'font-s margin-top-l'}
          data-testid='valuation-information-message-container'
        >
          {informationMessage}
        </div>
      )}
    </div>
  )
}

export { StyledValuationBar }
